import React from 'react'
import "./style.scss"
import { formateDateAndTime, formateDateTime } from '../../utils/commonFunctions';

const SingleCard = ({data}:any) => {

  const styleColor:any = (name: string) => {
    return {
      padding: "4px 12px",
      whiteSpace:"noWrap",
      color: `${
        name === "Good"
          ? "#82b01f"
          : name === "Obsolete"
          ? "#dd4433"
          : name === "Missing"
          ? "#262a44"
          : name === "Bad"
          ? "#f3a119"
          :name === "Yet to Capitalize"
          ? "rgb(32, 128, 246)"
          : ""
      }`,
      background: `${
        name === "Good"
          ? "#e7f0d4"
          : name === "Obsolete"
          ? "#ffebe9"
          : name === "Missing"
          ? "#f4f6f8"
          : name === "Bad"
          ? "#faedd8"
          : name === "Yet to Capitalize"
          ? "rgb(227, 239, 255)"
          : ""
      }`,
      width:`${
        name === "Good"
        ? "25%"
        : name === "Obsolete"
        ? "33%"
        : name === "Missing"
        ? "38%"
        : name === "Bad"
        ? "25%"
        : name === "Yet to Capitalize"
        ? "50%"
        : ""
      }`,
      borderRadius: "16px",
    };
  };

  return (
    <div className='m-4 d-flex single-container' >
        <div style={styleColor(data?.condition)}>{data?.condition}</div>

        <div className='d-flex' style={{justifyContent:"space-between",gap:"4px"}}>
            <div className='d-flex scan-header' style={{fontSize:"10px"}}>Finac Asset Id : <span className="text-box ml-1">{data?.finac_asset_id}</span></div>
            <div className='d-flex scan-header' style={{fontSize:"10px"}}>Asset Id : <span className="text-box ml-1">{data?.asset_id}</span></div>
        </div>

        <div className='mt-2 text' style={{wordWrap:"break-word"}}>
            {data?.asset_description}
        </div>

        <div className='mt-2  scan-header' style={{wordWrap:"break-word"}}>
            Last verified by {data?.verify_by_details?.first_name + " " + data?.verify_by_details?.last_name } on {formateDateTime(data?.verify_at)}
        </div>
    </div>
  )
}

export default SingleCard